import shortid from "shortid";
import Chip from "../chip/chip.component";
import Grid from "../grid/grid.component";
import Typography from "../typography/typography.component";
import { alpha } from "@mui/material";

const ListStatus = ({ listaStatus }) => {

  const renderLabel = (status) => {
    const texto = status.nome || status.status;
    const textoMinusculo = texto.toLowerCase();
    return textoMinusculo.charAt(0).toUpperCase()
      + textoMinusculo.slice(1);
  }

  return (
    <Grid container spacing={2}>
      {listaStatus.map((status) => (
        <Chip 
          className="d-flex mb-3 mx-2 p-1" 
          key={shortid.generate()} 
          icon={
            <i
              className="ph-fill ph-circle"
              style={{ color: status.cor, fontSize: 18, marginRight: 2 }}
            ></i>
          }
          label={<Typography>{renderLabel(status)}</Typography>}
          sx={{ 
            backgroundColor: alpha(status.cor, 0.08), 
            color: '#000' 
          }}
        />
      ))}
    </Grid>
  );
};

export default ListStatus;